/* eslint-disable react/prop-types */
/* eslint-disable prettier/prettier */
import PropTypes from "prop-types";
import React, { useState } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogActions from "@mui/material/DialogActions";
import Slide from "@mui/material/Slide";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import Alert from "@mui/material/Alert";
import Icon from "@mui/material/Icon";
import Collapse from "@mui/material/Collapse";
import { IconButton } from "@mui/material";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function ModalContent({
  title,
  open,
  handleClose,
  fullScreen,
  fullWidth,
  maxWidth,
  handleAcept,
  textAccept,
  alert,
  onCloseAlert,
  textCancelar,
  children,
}) {
  const { type, message, show } = alert;
  const [fullscreenM, setfullscreen] = useState(false);
  return (
    <Dialog
      open={open}
      TransitionComponent={Transition}
      keepMounted
      onClose={handleClose}
      fullScreen={fullscreenM}
      fullWidth={fullWidth}
      maxWidth={maxWidth}
    >
      <DialogTitle style={{ backgroundColor: "#1a2035" }}>{title}</DialogTitle>
      <DialogContent style={{ backgroundColor: "#1a2035" }}>
        <Collapse in={show}>
          <Alert severity={type} onClose={onCloseAlert}>
            <MDTypography variant="button" color="#000000">
              {message}
            </MDTypography>
          </Alert>
        </Collapse>
        <DialogContentText id="alert-dialog-slide-description">
          <MDBox py={3} px={2}>
            {children}
          </MDBox>
        </DialogContentText>
      </DialogContent>
      <DialogActions style={{ backgroundColor: "#1a2035" }}>
        <Button onClick={handleClose}>{textCancelar ? textCancelar : "Cancelar"}</Button>
        {textAccept ? <Button onClick={handleAcept}>{textAccept}</Button> : null}
        <IconButton onClick={() => setfullscreen(!fullscreenM)}>
          <Icon color="primary">{fullscreenM ? "fullscreen_exit" : "fullscreen"}</Icon>
        </IconButton>
      </DialogActions>
    </Dialog>
  );
}

ModalContent.defaultProps = {
  fullScreen: false,
  fullWidth: false,
  alert: {
    type: "",
    message: "",
    show: false,
  },
};

ModalContent.propTypes = {
  title: PropTypes.string.isRequired,
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  fullScreen: PropTypes.bool.isRequired,
  fullWidth: PropTypes.bool.isRequired,
  maxWidth: PropTypes.oneOf(["lg", "md", "sm", "xl", "xs"]),
  handleAcept: PropTypes.func.isRequired,
  alert: PropTypes.object.isRequired,
};

export default ModalContent;
